import React from "react";
import { Button } from "reactstrap";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { HomologarTitularMayorStore } from "../../../containers/personaReferencia/homologarTitularMayor/HomologarTitularMayor.store";
import { HomologarTitularMayorDispatcher } from "../../../containers/personaReferencia/homologarTitularMayor/HomologarTitularMayor.dispatcher";

interface Props
  extends HomologarTitularMayorStore,
    HomologarTitularMayorDispatcher {
  idMembresiaSocio: number;
  idTitular: number;
  onSuccess: () => void;
  onClose: () => void;
}

interface State {}

class HomologarTitularMayorComponent extends React.Component<Props, State> {
  state = {};

  componentWillUnmount() {
    this.props.clearPersonaReferencia();
  }

  handleConfirm = async () => {
    const {
      idMembresiaSocio,
      idTitular,
      putHomologarTitularMayor
    } = this.props;
    const preview = await putHomologarTitularMayor(idMembresiaSocio, idTitular);

    if (preview.fulfilled) {
      successNotification("Titular mayor de edad homologado exitosamente");
      this.props.onSuccess();
    } else {
      errorNotification(
        preview.puttingHomologarTitularMayorError ||
          "Error al homologar titular mayor de edad"
      );
    }
  };

  render() {
    const { puttingHomologarTitularMayor, idTitular } = this.props;

    return (
      <div>
        <p className="mb-4">
          ¿Está seguro de que desea homologar el titular mayor de edad con ID{" "}
          <strong>{idTitular}</strong>?
        </p>

        <div className="d-flex justify-content-end">
          <Button
            color="secondary"
            onClick={this.props.onClose}
            disabled={puttingHomologarTitularMayor}
            className="mr-3"
            size="sm"
          >
            Cancelar
          </Button>
          <Button
            className="primaryButton"
            onClick={this.handleConfirm}
            disabled={puttingHomologarTitularMayor}
            size="sm"
          >
            {puttingHomologarTitularMayor ? "Procesando..." : "Confirmar"}
          </Button>
        </div>
      </div>
    );
  }
}

export default HomologarTitularMayorComponent;
